<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>

    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSuccess" :message="message" />

    <form @submit.prevent="submitData()">
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">رقم الجوال:</label>
            <div class="fw-bold">{{ dataRow.mobile }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">القسم:</label>
            <div class="fw-bold">{{ dataRow.section === 'users' ? 'عميل' : 'مزود خدمة' }}</div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">تاريخ الطلب:</label>
            <div>{{ formatDate(dataRow.createdAt) }}</div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">الحالة الحالية:</label>
            <div>
              <span :class="statusBadge(dataRow.status)">{{ statusTranslate[dataRow.status] }}</span>
            </div>
          </div>
        </div>

        <div v-if="dataRow.status === 'new'" class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">تغيير الحالة:</label>
            <select v-model="status" class="form-control">
              <option value="approved">موافقة (استرداد الحساب)</option>
              <option value="rejected">رفض</option>
            </select>
          </div>
        </div>

        <div v-else class="alert alert-info mt-2">
          تم معالجة هذا الطلب مسبقاً ولا يمكن تعديله.
        </div>
      </div>

      <div class="card-footer" v-if="dataRow.status === 'new'">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">حفظ</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { toast, formatDate } from '@/helpers/tools';

export default {
  name: 'RestoreAccountsForm',
  props: {
    cardTitle: { type: String, default: 'طلب استرداد حساب' },
    dataRow: { type: Object, default: null },
  },
  data() {
    return {
      formLoader: false,
      hasError: false,
      hasSuccess: false,
      message: '',
      errorNumber: 0,
      status: 'approved',
      statusTranslate: {
        new: 'جديد',
        approved: 'موافق عليه',
        rejected: 'مرفوض',
      },
    };
  },
  methods: {
    formatDate,
    statusBadge(status) {
      return {
        'badge': true,
        'bg-warning text-dark': status === 'new',
        'bg-success': status === 'approved',
        'bg-danger': status === 'rejected',
      };
    },
    submitData() {
      this.formLoader = true;
      this.hasError = false;
      this.hasSuccess = false;
      this.$http.put(`/api/admin/restoreAccounts/update/${this.dataRow.id}`, {
        status: this.status,
      }).then(() => {
        this.message = this.status === 'approved'
          ? 'تمت الموافقة على الطلب واسترداد الحساب بنجاح'
          : 'تم رفض الطلب بنجاح';
        this.hasSuccess = true;
        this.dataRow.status = this.status;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created() {
    if (this.dataRow) {
      this.status = 'approved';
    }
  },
};
</script>